// this function only works on dom load, there is an identical function in the berocket plugin in the backend which activates on ajax load
jQuery(document).ready(function($){
    filtertextchange();

    function filtertextchange() {
        // array of inputs
        var checkbox = document.getElementById("berocket_aapf_single-5").getElementsByTagName("input");

        //when a checkbox is selected all other checkboxes are removed from the dom, so checkbox[0] will always be the selected input
        if( checkbox[0].checked == true ){
            // store data attribute on input
            var type = checkbox[0].getAttribute( 'data-term_name');

            if( type == 'Ceiling Lights' ){
                $('.hero_txt h1').html('Delight at pendants below in both Easy fit (on to your existing lamp holder) or as a high quality fitting connected by an Electrician.');
                document.getElementById("shop_hero").className="ceiling";
            }else if( type == 'Table and Floor' ){
                $('.hero_txt h1').html('Vast ranges of materials and styles from lily glasses to Mosaics in Stained glass to Metal desk lamps or LED to Animal lights. Enjoy choosing whichever you like.');
                document.getElementById("shop_hero").className="table_floor";
            }else if( type == 'Wall Lights' ){
                $('.hero_txt h1').html('Mosaics of stunning stained glass colours in traditional and modern styles or simple lily glasses fitted to a fancy metal wall light.');
                document.getElementById("shop_hero").className="wall";
            }else if( type == 'Accessories' ){
                $('.hero_txt h1').html('Accessorise your retro metal pendant by adding a matching colour suspension turning it from a pendant to fitting or choose a bulb to enhance the light in low energy of LED.');
                document.getElementById("shop_hero").className="accessories";
            }      
        }else{
            $('.hero_txt h1').html('You can click on Ranges, Colours, Styles etc on the left side of the screen to navigate the site easier and find what is most of interest to you.');
            document.getElementById("shop_hero").className="";
        } 
    }
});